import {SSORedirectError} from './types';

export const ssoRedirectErrorMessage = {
	[SSORedirectError.UserNotLinked]: 'User is not linked.',
	[SSORedirectError.SomethingWentWrong]: 'Uh oh. Something went wrong on our end.',
};